import { render, staticRenderFns } from "./createBatchNew.vue?vue&type=template&id=ab0a9908&scoped=true"
import script from "./createBatchNew.vue?vue&type=script&lang=js"
export * from "./createBatchNew.vue?vue&type=script&lang=js"
import style0 from "./createBatchNew.vue?vue&type=style&index=0&id=ab0a9908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0a9908",
  null
  
)

export default component.exports